import { motion } from 'framer-motion';
import { useFamily } from '../../contexts/FamilyContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';

export default function ConversationStartersAirbnb({ limit = 3, onStarterClick }) {
  const { family } = useFamily();

  // Generate personalized starters
  const starters = [
    {
      text: `Help me plan a Bar Mitzvah for a ${family?.kids?.[0]?.age || 12}-year-old`,
    },
    {
      text: 'What Hanukkah activities work for young kids?',
    },
    {
      text: 'Give me Passover menu ideas without cooking all day',
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.4 }}
    >
      <div className="flex items-center gap-2 mb-4">
        <FontAwesomeIcon icon={faLightbulb} className="text-primary" />
        <h3 className="font-serif font-bold text-lg text-text-primary">
          Conversation Starters
        </h3>
      </div>

      <div className="space-y-2">
        {starters.slice(0, limit).map((starter, index) => (
          <motion.button
            key={index}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            whileHover={{ scale: 1.01 }}
            onClick={() => onStarterClick(starter.text)}
            className="w-full bg-white border border-border rounded-lg p-4 hover:border-primary hover:shadow-sm transition-all duration-200 text-left group"
          >
            <p className="flex-1 font-medium text-text-primary group-hover:text-primary transition-colors">
              {starter.text}
            </p>
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
}
